import {EPreviewTextVariantKey, IPreviewTextVariant} from "./interfaces/preview-text-variant.interface";
import {defaultPreviewTexts} from "./consts/default";
import {EOrganizationType} from "../../../shared/enums/EOrganizationType";
import {performancePreviewTexts} from "./consts/performance";
import {clinicPreviewTexts} from "./consts/clinic";

export class PreviewTextService {
  private static _previewTextsConst: IPreviewTextVariant = defaultPreviewTexts;

  static setPreviewTextsConstKey(key: string, value: string) {
    PreviewTextService._previewTextsConst[key] = value ?? defaultPreviewTexts[key];
  }

  static setPreviewTexts(accountType: EOrganizationType): void {
    if(accountType === EOrganizationType.PERFORMANCE) PreviewTextService.previewTextsConst = performancePreviewTexts;
    else if(accountType === EOrganizationType.CLINIC) PreviewTextService.previewTextsConst = clinicPreviewTexts;
    else PreviewTextService.previewTextsConst = defaultPreviewTexts;
  }

  static set previewTextsConst(value: IPreviewTextVariant) {
    for(let key in EPreviewTextVariantKey) {
      PreviewTextService.setPreviewTextsConstKey(key, value[key]);
    }
  }

  static getPreviewText(key: EPreviewTextVariantKey): string {
    return PreviewTextService._previewTextsConst[key];
  }
}
